exports.list = {
    path: '/unit_monitoring',
    name: 'unit_monitoring_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/unit_monitoring/List.vue"),
}
exports.show = {
    path: '/unit_monitoring/show/:id',
    name: 'unit_monitoring_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/unit_monitoring/Show.vue"),
}